export enum Cursor {
  Move = "move",
  Auto = "auto"
}
